import {NgOptimizedImage} from "@angular/common";
import {Component, inject, ViewEncapsulation} from "@angular/core";
import {RouterLink} from "@angular/router";
import {map} from "rxjs";
import {rxSafeResource} from "../../helpers/ResourceHelpers";
import {Header} from "../../layout/header/header";
import {TeamMemberGender} from "../../models/Team/TeamMember";
import {SafeHtmlPipe} from "../../pipes/safe-html-pipe";
import {TeamApi} from "../../services/api/team-api";
import {TimelineApi} from "../../services/api/timeline-api";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.html",
  styleUrl: "./about-us.scss",
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [
    Header,
    SafeHtmlPipe,
    NgOptimizedImage,
    RouterLink,
  ],
})
export default class AboutUs {
  private readonly teamApi = inject(TeamApi);
  private readonly timelineApi = inject(TimelineApi);

  protected readonly applicationContactFormSubject = $localize`Bewerbung`;

  protected readonly team = rxSafeResource({
    stream: () => this.teamApi.getTeam().pipe(map(({entries}) => entries)),
    defaultValue: [],
  });
  protected readonly timeline = rxSafeResource({
    stream: () => this.timelineApi.getTimeline().pipe(map(({entries}) => entries)),
    defaultValue: [],
  });

  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly TeamMemberGender = TeamMemberGender;
}
